import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import GameHero from './GameHero'
import GameNews from './GameNews'
import GameSolution from './GameSolution'
import OurGame from './OurGame'
import { Helmet } from 'react-helmet'

const UnityGame = (props) => {
  const { game_slug } = useParams()
  // =========================== scroll To Top default =========================
  useEffect(() => {
    props.demo('top')
  }, [game_slug])
  // =========================== scroll To Top default =========================
  return (
    <>
      <Helmet>
        <title>IOT Dashboard and Analytics – Infograins</title>
        <meta name="description" content="Utilizing IoT Dashboard and Analytics with Infograins, a renowned IoT and Embedded firm, you can manage, control, and analyze your data." />
      </Helmet>
      <GameHero />
      <GameSolution />
      <OurGame />
      <GameNews />
    </>
  )
}

export default UnityGame